export default "__VITE_ASSET__DxC3AP8p__"